import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './layout/header/header';
import { Footer } from './layout/footer/footer';
import { SessionTimeout } from './layout/session-timeout/session-timeout';
import { StateManagementService } from './shared/services/state-management.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, SessionTimeout],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  private stateService = inject(StateManagementService);
  private destroy$ = new Subject<void>();
  protected readonly title = signal('ss-insights-ui');
  protected readonly isSessionTimedOut = signal(false);

  ngOnInit(): void {
    this.stateService.getIsSessionTimedOut()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isTimedOut) => {
        this.isSessionTimedOut.set(isTimedOut);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
